<div class="text-panel">
  <!-- Text styling panel (when text selected on preview) -->
  @if (selectedText()) {
    <evrideo-clipping-studio-text-styling-panel
      [textItem]="selectedText()!"
      [isEditMode]="state().mode === 'EDIT'"
      [templateId]="activeTemplateId()"
      [templateActionBusy]="templateActionBusy()"
      [currentTimeMs]="state().currentTimeMs ?? 0"
      [fps]="state().media?.fps ?? 30"
      (previewChange)="onPreviewText($event)"
      (update)="onUpdateText($event)"
      (close)="onCloseEditor($event)"
      (saveAsTemplate)="onSaveAsTemplate($event)"
      (updateTemplate)="onUpdateTemplate($event)"
      (deleteTemplate)="onDeleteTemplate($event)"
    ></evrideo-clipping-studio-text-styling-panel>
  }

  <!-- Catalogue (when no text selected) -->
  @if (!selectedText()) {
    <div class="text-panel__content">
      <!-- Basic add buttons -->
      <div class="text-panel__basic-section">
        <h3 class="text-panel__section-title">Basic</h3>
        <button type="button" class="text-panel__add-btn" (click)="addHeading()">
          <span class="text-panel__add-btn-text text-panel__add-btn-text--heading">Add heading</span>
          <span class="text-panel__add-icon">+</span>
        </button>
        <button type="button" class="text-panel__add-btn" (click)="addBodyText()">
          <span class="text-panel__add-btn-text">Add body text</span>
          <span class="text-panel__add-icon">+</span>
        </button>
      </div>

      <!-- Loading for text templates from API -->
      @if (textTemplatesLoading()) {
        <p class="text-panel__message">Loading text templates…</p>
      }

      <!-- Error message (same style as find-clip-panel) -->
      @if (textTemplatesError()) {
        <div class="text-panel__section text-panel__error">
          <p class="text-panel__error-text">{{ textTemplatesError() }}</p>
        </div>
      }

      <!-- All text templates in one grid -->
      @if (!textTemplatesLoading() && !textTemplatesError()) {
        <div class="text-panel__grid">
          @for (tmpl of templates(); track tmpl.id) {
            <evrideo-clipping-studio-text-template-card
              [template]="tmpl"
              [isEditMode]="isEditMode()"
              (add)="onAddTemplate($event)"
              (edit)="onEditTemplate($event)"
              (delete)="onDeleteTemplateFromCard($event)"
            ></evrideo-clipping-studio-text-template-card>
          }
        </div>
      }
    </div>
  }
</div>
